function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import Flex from './Flex';
import PropTypes from 'prop-types';
import React from 'react';
import { Transition } from 'react-transition-group';
const duration = 300;
const defaultStyle = function () {
  let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
  return {
    transition: `transform ${duration}ms ease-in-out`,
    transform: `translateX(${direction === 'left' ? '-' : ''}${width}px)`
  };
};
const transitionStyles = function () {
  let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
  return {
    entering: {
      transform: `translateX(0px)`
    },
    entered: {
      transform: `translateX(0px)`
    },
    exiting: {
      transform: `translateX(${direction === 'left' ? '-' : ''}${width}px)`
    },
    exited: {
      transform: `translateX(${direction === 'left' ? '-' : ''}${width}px)`
    }
  };
};
const Drawer = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    direction = 'right',
    width = 320,
    ...props
  } = _ref;
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setTimeout(() => setMounted(true));
  }, []);
  return /*#__PURE__*/React.createElement(Transition, {
    in: mounted,
    timeout: duration
  }, state => /*#__PURE__*/React.createElement(Flex, _extends({
    ref: ref,
    sx: {
      flexDirection: 'column',
      bg: 'background',
      height: '100%',
      maxWidth: '100vw',
      width,
      position: 'absolute',
      [direction]: 0
    },
    style: {
      ...defaultStyle(width, direction),
      ...transitionStyles(width, direction)[state]
    }
  }, props)));
}));
Drawer.propTypes = {
  direction: PropTypes.oneOf(['right', 'left']),
  width: PropTypes.number
};
Drawer.displayName = 'Drawer';
export default Drawer;